// Import React for component creation
import React from "react";
// Import CSS for hero section styling
import "../../css/components/Hero.css";

/**
 * Helper function to render multi-line text with line breaks.
 * Splits the input text by newlines and inserts <br /> elements.
 */
const renderLines = (text) => {
  const lines = text.split("\n");
  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};

/**
 * Hero component for displaying a prominent section with background, title, subtitle, and optional logo.
 *
 * Props:
 * - title: Main heading text (supports multi-line)
 * - subtitle: Subheading text (supports multi-line)
 * - backgroundImage: URL for background image
 * - logo: Optional logo image URL
 * - titleAlign: Alignment for the title ("center" | "left")
 * - subtitleAlign: Alignment for the subtitle ("center" | "left")
 * - lightOverlay: Whether to use a light overlay on the background
 */
function Hero({
  title = "", // Main heading
  subtitle = "", // Subheading
  backgroundImage = "", // Background image URL
  logo, // Optional logo image
  titleAlign = "center", // Title alignment
  subtitleAlign = "center", // Subtitle alignment
  lightOverlay = false, // Light overlay toggle
  children, // Optional children for additional content (e.g., buttons) 
}) {
  return (
    <section
      className="hero"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      {/* Overlay for background, can be light or default */}
      <div className={`hero-overlay ${lightOverlay ? "light-overlay" : ""}`}>
        <div className="hero-content">
          {/* Optional logo */}
          {logo && <img src={logo} alt="Logo" className="hero-logo" />}
          {/* Title with alignment and multi-line support */}
          {/* <h1 className="font-hero-title" style={{ textAlign: titleAlign }}>
            {renderLines(title)}
          </h1> */}
          {/* Divider under the title */}
          {/* <div className={`divider align-${titleAlign}`}></div> */}
          {/* Subtitle with alignment and multi-line support */}
          {/* <p style={{ textAlign: subtitleAlign }}>{renderLines(subtitle)}</p> */}
          {/*
            Button support can be enabled here if needed:
            {buttonText && (
              <Button
                text={buttonText}
                variant="primary"
                onClick={onButtonClick}
              />
            )}
          */}
          {children}
        </div>
      </div>
    </section>
  );
}

// Export the Hero component as default
export default Hero;
